import { createAction, props } from "@ngrx/store";
import { FilterStatement } from "src/app/models/statement/filter-statement";
import { Statement } from "src/app/models/statement/statement";
import { SummaryStatement } from "src/app/models/statement/summary-statement";

export enum BankStatementActionsType {
  SET_STATEMENT_FILTER = '[BANK-STATEMENT] Filter bank statement',
  SET_SUMMARY = '[BANK-STATEMENT] bank statement summary',
  SET_STATEMENT = '[BANK-STATEMENT] bank statement',
  SET_FULL_STATEMENT = '[BANK-FULL-STATEMENT] bank full statement',
  SET_ACCOUNT_STATEMENT = '[BANK-STATEMENT] bank account',
  SET_DATE = '[BANK-STATEMENT] range date',
  CHANGE_FILTER = '[BANK] Change filter',
  SET_STATEMENT_DATA = '[BANK-STATEMENT] Set statement data',
  SET_PAGINATION_DATA = '[BANK-STATEMENT] Set pagination data',
  CLEAR_STATEMENT = '[BANK-STATEMENT] Clear statement'
}


export const setStatementFilter = createAction(
  BankStatementActionsType.SET_STATEMENT_FILTER,
  props<{ filters: FilterStatement }>()
)

export const setSummary = createAction(
  BankStatementActionsType.SET_SUMMARY,
  props<{ summary: SummaryStatement }>()
)

export const setStatement = createAction(
  BankStatementActionsType.SET_STATEMENT,
  props<{ statement: Array<Statement> }>()
)

export const setFullStatement = createAction(
  BankStatementActionsType.SET_FULL_STATEMENT,
  props<{ fullStatement: Array<Statement> }>()
)

export const setDate = createAction(
  BankStatementActionsType.SET_DATE,
  props<{ rangeDate: string }>()
)

export const changeFilter = createAction(
  BankStatementActionsType.CHANGE_FILTER,
  props<{ value: string }>()
)

export const setStatementData = createAction(
  BankStatementActionsType.SET_STATEMENT_DATA,
  props<{ statement: Statement }>()
)

export const setPaginationData = createAction(
  BankStatementActionsType.SET_PAGINATION_DATA,
  props<{ paginationData: any }>()
)

export const clearStatement = createAction(
  BankStatementActionsType.CLEAR_STATEMENT
)